import axios from 'axios'

let baseURL = process.env.VUE_APP_BASE_API
const straightBaseURL =  "https://api.yuncai-tech.com"
const testBaseURL = "https://api.yuncai-tech.com"
if(baseURL != '/api'){
  if(window.JS){
    if(!JS.getIsDebug){
      baseURL = straightBaseURL
    }else{
      baseURL = JS.getIsDebug() == 'false' ? straightBaseURL : testBaseURL
    }
  }else{
    baseURL = straightBaseURL
  }
}
if(window.location.host == "tadmin.yuncai-tech.com"){
  baseURL = testBaseURL
}
import store from "../store"

// create an axios instance
const service = axios.create({
  baseURL, 
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
      config.headers['Authorization'] = 'Bearer ' + store.state.token
      // config.headers['Authorization'] = store.state.token
      // config.headers['Authorization'] = store.state.token || '32d0aed6f8db7608026752bf3c95f325'
      // config.headers['Authorization'] = store.state.token || '8214e0871978e6238767f294abcd6f11'
    return config
  },
  error => {
    console.log(error) 
    return Promise.resolve(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    return res
  },
  error => {
    console.log('err1' + error) 
    return Promise.resolve(error)
  }
)

export default service
